<template>
	<div>
		<!-- <app-header></app-header> -->
		<div class="l-container main-page">
			<div class="download-wrap">
				<a href="/static/brochure/XEOGEN_WebAgency_KOR.pdf" target="_blank">
					<div class="svg-set is-rotate"></div>
					<div class="svg-arrow is-down"></div>
				</a>
			</div>
			<div class="swiper-container view-main">
				<ul class="swiper-wrapper">
					<li class="swiper-slide slide-hos">
						<div class="info-wrap">
							<strong class="tit">HMC <br />Online Direct <br />Sales Platform</strong>
							<div class="view-detail-btn-wrap">
								<a href="/uiux/hos-hk"><span class="text">view detail</span></a>
							</div>
						</div>
						<div class="slice-item slice-item-01"></div>
						<div class="slice-item slice-item-02"></div>
						<div class="slice-item slice-item-03"></div>
						<div class="slice-item slice-item-04"></div>
						<div class="slice-item slice-item-05"></div>
					</li>
					<li class="swiper-slide slide-ing-life">
						<div class="info-wrap">
							<strong class="tit">ING Life <br />Mobile Center</strong>
							<div class="view-detail-btn-wrap">
								<a href="/uiux/ing-life"><span class="text">view detail</span></a>
							</div>
						</div>
						<div class="slice-item slice-item-01"></div>
						<div class="slice-item slice-item-02"></div>
						<div class="slice-item slice-item-03"></div>
						<div class="slice-item slice-item-04"></div>
						<div class="slice-item slice-item-05"></div>
					</li>
					<li class="swiper-slide slide-kb-card">
						<div class="info-wrap">
							<strong class="tit">KB <br />Corporate Card <br />Mobile App</strong>
							<div class="view-detail-btn-wrap">
								<a href="/uiux/kb-card"><span class="text">view detail</span></a>
							</div>
						</div>
						<div class="slice-item slice-item-01"></div>
						<div class="slice-item slice-item-02"></div>
						<div class="slice-item slice-item-03"></div>
						<div class="slice-item slice-item-04"></div>
						<div class="slice-item slice-item-05"></div>
					</li>
					<li class="swiper-slide slide-hanssem">
						<div class="info-wrap">
							<strong class="tit">Hanssem.com <br />O4O Platform</strong>
							<div class="view-detail-btn-wrap">
								<a href="/uiux/hanssem-o4o"><span class="text">view detail</span></a>
							</div>
						</div>
						<div class="slice-item slice-item-01"></div>
						<div class="slice-item slice-item-02"></div>
						<div class="slice-item slice-item-03"></div>
						<div class="slice-item slice-item-04"></div>
						<div class="slice-item slice-item-05"></div>
					</li>
				</ul>
				<!-- Add Arrows -->
				<div class="swiper-button-next"></div>
				<div class="swiper-button-prev"></div>
			</div>
		</div>
		<!-- <app-footer></app-footer> -->
	</div>
</template>

<script>
import WheelIndicator from "../../static/js/wheel-indicator.js";
import Swiper from "../../static/js/swiper.min.js";

export default {
	metaInfo: {
		title: "Main",
		meta: [
			{
				vmid: "description",
				name: "description",
				content:
					"항상 최고의 서비스를 제공하고 미래가치를 발전시켜 나가는 크리에이티브 그룹 제오젠입니다.",
			},
		],
	},
	data() {
		return {
			noneHref: null,
			currentRoute: window.location.pathname,
			headerFixed: true,
		};
	},
	mounted: function () {
		$("#app").addClass("xg-main");
		ratio();

		var ratioTimeout;

		$(window).on("resize", function () {
			ratio();
			clearTimeout(ratioTimeout);
			ratioTimeout = setTimeout(ratio, 500);
		});

		var windowRatio;
		var imgRatio;
		function ratio() {
			var w = $(window).width();
			var h = $(window).height();
			var imgSize = {
				mobile: {
					width: 640,
					height: 1136,
				},
				tablet: {
					width: 1424,
					height: 2276,
				},
				pc: {
					width: 2560,
					height: 1440,
				},
			};

			windowRatio = h / w;

			if (w < 712) {
				imgRatio = imgSize.mobile.height / imgSize.mobile.width;
				imgSet();
			} else if (w >= 712 && w < 1280) {
				imgRatio = imgSize.tablet.height / imgSize.tablet.width;
				imgSet();
			} else if (w >= 1280) {
				imgRatio = imgSize.pc.height / imgSize.pc.width;
				imgSet();
			}
		}

		function imgSet() {
			var w = $(window).width();
			var h = $(window).height();
			var $target = $(".view-main .swiper-slide");
			var itemW = $(".slice-item").width();
			var itemLen = 5;
			var ratioW = h / imgRatio;
			var ratioH = imgRatio * w;

			var $viewMain = $(".view-main");
			$viewMain.find(".swiper-slide").each(function () {
				if (windowRatio > imgRatio) {
					$(this)
						.find(".slice-item")
						.css("background-size", ratioW + "px " + h + "px");
					for (var i = 0; i < itemLen; i++) {
						$(this)
							.find(".slice-item")
							.eq(i)
							.css("background-position-x", (w - ratioW) / 2 - itemW * i);
					}
				} else {
					$(this)
						.find(".slice-item")
						.css("background-size", w + "px " + ratioH + "px");
					for (var i = 0; i < itemLen; i++) {
						$(this)
							.find(".slice-item")
							.eq(i)
							.css("background-position-x", -(itemW * i));
					}
				}
			});
		}

		var viewMain = new Swiper(".view-main", {
			speed: 600,
			loop: true,
			// mousewheel: {
			//     invert: false,
			// },
			navigation: {
				nextEl: ".view-main .swiper-button-next",
				prevEl: ".view-main .swiper-button-prev",
			},
		});

		var indicator = new WheelIndicator({
			callback: function (e) {
				if (e.direction == "down") {
					viewMain.slideNext();
				} else {
					viewMain.slidePrev();
				}
			},
			preventMouse: false,
		});

		// $('.btn-sidemenu').addClass('is-active');

		//window back button click
		// window.onpopstate = function(event) {
		//     location.href = '/main';
		// }
	},
	methods: {},
	components: {},
	created() {
		//console.log("xgmain");
	},
};
</script>


// WEBPACK FOOTER //
// src/components/XgMain.vue